import io from "socket.io-client";

export const createSocket = (userId: string) => {
  const socket = io("https://server.saasaki.com", {
    query: {
      employeeId: userId,
    },
  });

  console.log("Socket connector", {
    userId,
    socket,
  });

  return socket;
};
